import React from 'react';
import { Typography } from '@mui/material';
import GenericPage from '../../Commun/components/GenericPage';

const SettingsPage: React.FC = () => {
    return (
        <GenericPage title="Paramètres">
            <Typography variant="body1">Paramètres du parc (en cours de développement)</Typography>
        </GenericPage>
    );
};

export default SettingsPage;
